export default __webpack_public_path__ + "static/media/BnR-Logo-Icon-White.0467cff0.png";